/* =====================================================================
   NUCLEAR PRODUCT PAGE — scripts moved from sections/nuclear-product.liquid

   What's in here:
   - PDP-LIFECYCLE / utility scripts that ran inline at the top of the
     section (variant selection wiring, button handlers, etc.).
   - STICKY-CART hoist-to-<body> lifecycle (was just below {% endschema %}
     in the old file, which is invalid Shopify section syntax).

   What stays INLINE in nuclear-product.liquid:
   - The window.pdpVariantData = { ... } JSON injection. It uses Liquid
     ({{ variant.* | json }}) and therefore must be server-rendered.
     That's the only script in the section file now.
   ===================================================================== */

// --- moved from <script> #1 (was lines 101–501) ---
// ============================================
// CART MANAGER - Only define if not already global
// (Now also defined in global-utilities.liquid)
// ============================================


// ============================================
// STICKY CART STATE
// ============================================
window.stickyCartQty = 0;
window.drawerExpanded = false;

// Expand drawer - uses ModalManager
function expandDrawer() {
  if (window.drawerExpanded) return;
  if (window.ModalManager && ModalManager.modals['sticky-cart-drawer']) {
    ModalManager.open('sticky-cart-drawer');
  } else {
    // Fallback if ModalManager not ready
    const drawer = document.getElementById('mobileCartBar');
    const backdrop = document.getElementById('drawerBackdrop');
    if (drawer) {
      window.drawerExpanded = true;
      drawer.classList.add('expanded');
      if (backdrop) backdrop.classList.add('visible');
    }
  }
}

// Collapse drawer - uses ModalManager
function collapseDrawer() {
  if (!window.drawerExpanded) return;
  if (window.ModalManager && ModalManager.modals['sticky-cart-drawer']) {
    ModalManager.close('sticky-cart-drawer');
  } else {
    // Fallback
    const drawer = document.getElementById('mobileCartBar');
    const backdrop = document.getElementById('drawerBackdrop');
    if (drawer) {
      window.drawerExpanded = false;
      drawer.classList.remove('expanded');
      if (backdrop) backdrop.classList.remove('visible');
    }
  }
}

// Toggle drawer
function toggleDrawer() {
  if (window.drawerExpanded) {
    collapseDrawer();
  } else {
    expandDrawer();
  }
}

// Sticky Cart Add - Uses CartManager
function addToCartFromSticky() {
  addToCartFromMobile({ openDrawer: true });
}

// Global Product Page Initialization - runs on page load AND page transitions
window.initProductPage = function() {
  const handle = document.getElementById('drawerHandle');
  const backdrop = document.getElementById('drawerBackdrop');

  if (window.ModalManager && !ModalManager.modals['sticky-cart-drawer']) {
    ModalManager.register('sticky-cart-drawer', {
      element: '#mobileCartBar',
      useBackdrop: false,
      closeOnBackdrop: true,
      onOpen: function(el) {
        window.drawerExpanded = true;
        el.classList.add('expanded');
        const drawerBackdrop = document.getElementById('drawerBackdrop');
        if (drawerBackdrop) drawerBackdrop.classList.add('visible');
      },
      onClose: function(el) {
        window.drawerExpanded = false;
        el.classList.remove('expanded');
        const drawerBackdrop = document.getElementById('drawerBackdrop');
        if (drawerBackdrop) drawerBackdrop.classList.remove('visible');
      }
    });
  }
  
  // Click handle to toggle
  if (handle && !handle._initialized) {
    handle.addEventListener('click', toggleDrawer);
    handle._initialized = true;
  }
  
  // Click backdrop to close
  if (backdrop && !backdrop._initialized) {
    backdrop.addEventListener('click', collapseDrawer);
    backdrop._initialized = true;
  }
  
  // Swipe down to close
  const drawer = document.getElementById('mobileCartBar');
  if (drawer && !drawer._swipeInitialized) {
    let touchStartY = 0;
    drawer.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    
    drawer.addEventListener('touchend', (e) => {
      const touchEndY = e.changedTouches[0].clientY;
      const swipeDistance = touchEndY - touchStartY;
      if (swipeDistance > 50 && window.drawerExpanded) {
        collapseDrawer();
      }
    }, { passive: true });
    drawer._swipeInitialized = true;
  }
  
  // Shipping Urgency Calculator
  if (typeof window.updateShippingUrgency === 'function') {
    window.updateShippingUrgency();
  }

  initFlavorStoriesRail();
  
  // STICKY CART SCROLL TRIGGER
  // First, kill the prior page's scroll handler if any. Without this,
  // every SPA navigation between product pages adds another scroll
  // listener bound to a now-detached purchaseOption, leaking forever.
  if (window._stickyCartScrollHandler) {
    window.removeEventListener('scroll', window._stickyCartScrollHandler);
    window.removeEventListener('resize', window._stickyCartResizeHandler);
    window._stickyCartScrollHandler = null;
    window._stickyCartResizeHandler = null;
  }

  const stickyCart = document.getElementById('mobileCartBar');
  const purchaseOption = document.querySelector('.purchase-option');
  const navbar = document.querySelector('.header-wrapper') || document.querySelector('.site-nav') || document.querySelector('header');

  if (stickyCart && purchaseOption) {
    let ticking = false;

    function checkStickyVisibility() {
      // Re-resolve elements every tick so a swapped DOM doesn't leak.
      const cart = document.getElementById('mobileCartBar');
      const anchor = document.querySelector('.purchase-option');
      if (!cart || !anchor) return;
      const rect = anchor.getBoundingClientRect();
      const navBottom = navbar ? navbar.getBoundingClientRect().bottom : 56;
      const shouldShow = rect.top <= navBottom;
      cart.classList.toggle('visible-scroll', shouldShow);
    }

    const onStickyScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        checkStickyVisibility();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onStickyScroll, { passive: true });
    window.addEventListener('resize', checkStickyVisibility, { passive: true });
    checkStickyVisibility(); // Initial check

    // Track on window so the next initProductPage() can detach them
    // regardless of which cart DOM node is currently mounted.
    window._stickyCartScrollHandler = onStickyScroll;
    window._stickyCartResizeHandler = checkStickyVisibility;
  }
};

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  window.initProductPage();
  // Start the shipping-urgency tick once. Stored on window so SPA
  // navigation away from the product page (handled by the hoist IIFE
  // below) can clear it via window._shippingIntervalId.
  if (!window._shippingIntervalId) {
    window._shippingIntervalId = setInterval(window.updateShippingUrgency, 60000);
  }
});

// Run on page transitions (SPA navigation).
// This script is inside <main> so page-transitions.js re-executes the
// whole block on every SPA nav. Guard against accumulating duplicate
// window listeners (each nav otherwise adds another initProductPage
// listener which fires multiple times).
if (!window._pdpInitListenerBound) {
  window.addEventListener('pageTransitionComplete', function() {
    window.initProductPage();
  });
  window._pdpInitListenerBound = true;
}

// Global Shipping Urgency Calculator - Updates both locations
window.updateShippingUrgency = function() {
  const now = new Date();
  const day = now.getDay(); // 0 = Sunday
  const hours = now.getHours();
  const minutes = now.getMinutes();
  
  // Cutoff is 2 PM (14:00)
  const cutoffHour = 14;
  
  const icon = '<svg class="ship-icon" width="14" height="14" viewBox="0 0 24 24" fill="#FDB91A"><path d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm1.5-9H17V12h4.46L19.5 9.5zM6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3z"/></svg>';
  
  const gold = '#FDB91A';
  let textOnly = '';
  let fullHTML = '';
  let mobileText = '';
  
  // Calculate the text with highlighted time
  if (day === 0) {
    fullHTML = icon + ` Ships <span style="color:${gold}">Monday</span>`;
    mobileText = `Ships <span style="color:${gold}">Monday</span>`;
  } else if (hours < cutoffHour) {
    const hoursLeft = cutoffHour - hours - 1;
    const minsLeft = 60 - minutes;
    
    if (hoursLeft === 0) {
      fullHTML = icon + ` Ships <span style="color:${gold}">today</span>! Order in <span style="color:${gold}">${minsLeft}m</span>`;
      mobileText = `Ships <span style="color:${gold}">today</span>! Order in <span style="color:${gold}">${minsLeft}m</span>`;
    } else {
      fullHTML = icon + ` Ships <span style="color:${gold}">today</span>! Order in <span style="color:${gold}">${hoursLeft}h ${minsLeft}m</span>`;
      mobileText = `Ships <span style="color:${gold}">today</span>! Order in <span style="color:${gold}">${hoursLeft}h ${minsLeft}m</span>`;
    }
  } else {
    if (day === 6) {
      fullHTML = icon + ` Ships <span style="color:${gold}">Monday</span>`;
      mobileText = `Ships <span style="color:${gold}">Monday</span>`;
    } else {
      fullHTML = icon + ` Ships <span style="color:${gold}">tomorrow</span>`;
      mobileText = `Ships <span style="color:${gold}">tomorrow</span>`;
    }
  }
  
  // Update sticky cart shipping text
  const stickyShipEl = document.getElementById('shippingUrgency');
  if (stickyShipEl) {
    stickyShipEl.innerHTML = fullHTML;
  }
  
  // Update mobile product section shipping text (with HTML)
  const mobileShipEl = document.querySelector('#mobileShipTime .ship-text-dynamic');
  if (mobileShipEl) {
    mobileShipEl.innerHTML = mobileText;
  }
};

// Auto-scrolling Reviews with infinite loop
// [Legacy Script Removed]









































// Accordion Toggle
function toggleAccordion(button) {
  const item = button.parentElement;
  item.classList.toggle('open');
}

function initFlavorStoriesRail() {
  const track = document.getElementById('flavorStoriesTrack');
  if (!track || track.dataset.loopReady === 'true') return;

  const originalCards = Array.from(track.children);
  if (originalCards.length < 2) return;

  const makeClone = (card) => {
    const clone = card.cloneNode(true);
    clone.classList.add('story-clone');
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('inert', '');
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
      el.setAttribute('tabindex', '-1');
      el.setAttribute('aria-hidden', 'true');
    });
    return clone;
  };

  originalCards.slice().reverse().forEach((card) => {
    track.insertBefore(makeClone(card), track.firstChild);
  });

  originalCards.forEach((card) => {
    track.appendChild(makeClone(card));
  });

  const getGap = () => {
    const styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap || '14') || 14;
  };

  const getMetrics = () => {
    const styles = window.getComputedStyle(track);
    const gap = getGap();
    const padLeft = parseFloat(styles.paddingLeft || '0') || 0;
    const firstRealStart = originalCards[0].offsetLeft - padLeft;
    const originalSpan = originalCards.reduce((sum, card, index) => {
      return sum + card.offsetWidth + (index < originalCards.length - 1 ? gap : 0);
    }, 0);
    return {
      originalSpan,
      firstRealStart
    };
  };

  const resetToMiddle = () => {
    const { firstRealStart } = getMetrics();
    if (firstRealStart >= 0) {
      track.scrollLeft = firstRealStart;
    }
  };

  let correcting = false;
  const handleLoop = () => {
    if (correcting) return;

    const { originalSpan, firstRealStart } = getMetrics();
    if (!originalSpan) return;

    const startBoundary = firstRealStart - (originalSpan * 0.35);
    const endBoundary = firstRealStart + originalSpan + (originalSpan * 0.35);

    if (track.scrollLeft <= startBoundary) {
      correcting = true;
      track.scrollLeft += originalSpan;
      requestAnimationFrame(() => { correcting = false; });
    } else if (track.scrollLeft >= endBoundary) {
      correcting = true;
      track.scrollLeft -= originalSpan;
      requestAnimationFrame(() => { correcting = false; });
    }
  };

  requestAnimationFrame(resetToMiddle);
  track.addEventListener('scroll', handleLoop, { passive: true });
  window.addEventListener('resize', resetToMiddle, { passive: true });
  track.dataset.loopReady = 'true';
}

// Purchase option toggle
// Purchase option toggle - STRICT Radio Logic
document.querySelectorAll('input[name="purchase_type"]').forEach(radio => {
  radio.addEventListener('change', function() {
    // 1. Remove .selected from ALL options
    document.querySelectorAll('.purchase-option').forEach(o => o.classList.remove('selected'));
    
    // 2. Add .selected to the parent of the currently checked radio
    if (this.checked) {
      this.closest('.purchase-option').classList.add('selected');
      if (typeof window.syncPdpPurchaseState === 'function') {
        window.syncPdpPurchaseState(window.getSelectedPdpVariantId());
      }
    }
  });
});

// Init state
document.querySelectorAll('input[name="purchase_type"]:checked').forEach(radio => {
    radio.closest('.purchase-option').classList.add('selected');
});

// --- moved from <script> #3 (was lines 4298–4421, sticky-cart lifecycle) ---
/* ============================================================
   STICKY CART LIFECYCLE — robust across SPA navigation
   ============================================================
   Why we hoist to <body>:
   The cart is `position: fixed` but sits inside #MainContent. Any
   stacking context on an ancestor (e.g. #MainContent z-index, footer
   isolation, a transform somewhere) traps the cart's z-index inside
   that bubble — making the cart hide behind the footer regardless of
   how high the cart's own z-index is. Hoisting it to <body> escapes
   all ancestor stacking contexts permanently.

   Invariants enforced below:
   - At most ONE .mobile-sticky-cart in the document at any time.
   - On every SPA navigation, the new product page's freshly-rendered
     cart REPLACES any prior body-level orphan from the previous nav.
   - On navigation to a non-product page, body-level orphans are removed.
   ============================================================ */

(function() {
  const STICKY_SELECTOR = '.mobile-sticky-cart';
  const STICKY_ID = 'mobileCartBar';
  const BACKDROP_ID = 'drawerBackdrop';

  function isProductPage() {
    return !!document.querySelector('.nuclear-product-wrapper, .nuclear-product-page, .template-product');
  }

  function removeOrphanCarts(keepNode) {
    // Remove every .mobile-sticky-cart except the one we want to keep.
    document.querySelectorAll(STICKY_SELECTOR).forEach(node => {
      if (node !== keepNode) {
        node.classList.remove('visible-scroll', 'expanded');
        // Detach any tracked window-level scroll handler attached to this node
        if (node._scrollHandler) {
          window.removeEventListener('scroll', node._scrollHandler);
          window.removeEventListener('resize', node._scrollHandler);
          node._scrollHandler = null;
          node._scrollInitialized = false;
        }
        node.remove();
      }
    });

    // Clean up any orphan backdrop sitting at body level
    document.querySelectorAll('#' + BACKDROP_ID).forEach(b => {
      if (!keepNode || b.previousElementSibling !== keepNode) {
        b.classList.remove('visible');
        // Keep only one backdrop if a cart is kept; remove the rest
        const all = document.querySelectorAll('#' + BACKDROP_ID);
        if (all.length > 1) b.remove();
      }
    });
  }

  // Public API: move the current page's sticky cart to <body> and
  // remove any prior orphans. Idempotent — safe to call repeatedly.
  window.hoistProductStickyCart = function() {
    // Prefer the cart still inside <main> (freshly rendered); fall back
    // to any body-level cart already hoisted earlier.
    const main = document.querySelector('main, #MainContent') || document.body;
    const inMain = main.querySelector(STICKY_SELECTOR);
    const cart = inMain || document.body.querySelector(':scope > ' + STICKY_SELECTOR);

    if (!cart) {
      // No cart on this page (e.g. non-product). Remove any orphan.
      removeOrphanCarts(null);
      return;
    }

    // Remove every other cart, then move the chosen one to body if needed.
    removeOrphanCarts(cart);
    if (cart.parentElement !== document.body) {
      document.body.appendChild(cart);
    }
  };

  // Public API: full teardown — used when explicitly leaving a product page.
  window.teardownProductStickyCart = function() {
    if (window.ModalManager && window.ModalManager.active === 'sticky-cart-drawer') {
      ModalManager.close('sticky-cart-drawer');
    }

    removeOrphanCarts(null);

    if (window.ModalManager && window.ModalManager.modals && window.ModalManager.modals['sticky-cart-drawer']) {
      delete window.ModalManager.modals['sticky-cart-drawer'];
    }

    // Stop the per-minute shipping urgency tick.
    if (window._shippingIntervalId) {
      clearInterval(window._shippingIntervalId);
      window._shippingIntervalId = null;
    }

    window.drawerExpanded = false;
    window.stickyCartQty = 0;
  };

  function syncStickyCartForCurrentPage() {
    if (isProductPage()) {
      window.hoistProductStickyCart();
    } else {
      // Navigated away from a product page — purge any orphan.
      removeOrphanCarts(null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStickyCartForCurrentPage);
  } else {
    syncStickyCartForCurrentPage();
  }

  // Re-run after every SPA navigation. Guard against re-binding: this
  // script lives inside <main> and gets re-executed on every SPA nav by
  // page-transitions.js' script-revival logic. Without the guard each
  // nav adds another listener that fires sync over and over.
  if (!window._stickyCartHoistListenerBound) {
    window.addEventListener('pageTransitionComplete', syncStickyCartForCurrentPage);
    window._stickyCartHoistListenerBound = true;
  }
})();


/* =====================================================================
   PDP CONTROLLER (Round 2): moved from the remaining inline <script>
   in sections/nuclear-product.liquid. The only inline JS left in the
   section is the variant-data block + default-variant-id, both of
   which are server-rendered.
   ===================================================================== */
/* ========================================
   NUCLEAR PDP CONTROLLER (Refined & Optimistic)
   ======================================== */

document.addEventListener('DOMContentLoaded', () => {
  if (!window.ActionHandler) return;

  ActionHandler.register('change-hero', (el) => {
    if (typeof changeHeroImage === 'function') {
      changeHeroImage(el.dataset.imageSrc, el);
    }
  });

  // PDP delegated actions (replaced inline onclick across sticky cart,
  // pack-size variant chips, and the mobile split add-to-cart button).
  ActionHandler.register('sticky-add', () => {
    if (typeof window.addToCartFromSticky === 'function') {
      window.addToCartFromSticky();
    }
  });
  ActionHandler.register('mobile-pdp-add', () => {
    if (typeof window.addToCartFromMobile === 'function') {
      window.addToCartFromMobile();
    }
  });
  ActionHandler.register('select-stack-variant', (el) => {
    if (typeof window.selectStackVariant === 'function') {
      window.selectStackVariant(el, el.dataset.variantId);
    }
  });
});

// WAYS TO ENJOY - Video Carousel Controller (Infinite Loop)
(function() {
  const track = document.getElementById('waysTrack');
  const dotsContainer = document.getElementById('waysDots');
  if (!track) return;
  
  const originalCards = Array.from(track.querySelectorAll('.way-card'));
  if (originalCards.length < 2) return;
  
  // Clone cards to create a buffer on both sides
  const clonesCount = originalCards.length;
  
  // Prep starting clones
  originalCards.reverse().forEach(card => {
    track.prepend(card.cloneNode(true));
  });
  originalCards.reverse(); // put back in order
  
  // Prep ending clones
  originalCards.forEach(card => {
    track.appendChild(card.cloneNode(true));
  });
  
  const allCards = Array.from(track.querySelectorAll('.way-card'));
  
  // Create dots only if container exists
  let dots = [];
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    originalCards.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => {
        const targetIdx = clonesCount + i;
        scrollToCardIndex(targetIdx);
      });
      dotsContainer.appendChild(dot);
    });
    dots = dotsContainer.querySelectorAll('.dot');
  }
  
  function getCardWidth() {
    return allCards[0].offsetWidth + 24; // width + gap (1.5rem = 24px)
  }

  function scrollToCardIndex(index) {
    const cardWidth = getCardWidth();
    const trackWidth = track.offsetWidth;
    const cardElWidth = allCards[0].offsetWidth;
    const scrollPos = (index * cardWidth) - (trackWidth / 2) + (cardElWidth / 2);
    track.scrollTo({ left: scrollPos, behavior: 'smooth' });
  }

  function handleInfiniteScroll() {
    const cardWidth = getCardWidth();
    const totalOriginalWidth = originalCards.length * cardWidth;
    const scrollLeft = track.scrollLeft;
    
    // If we've scrolled into the start clones buffer
    if (scrollLeft < totalOriginalWidth * 0.5) {
      track.scrollTo({ left: scrollLeft + totalOriginalWidth, behavior: 'instant' });
    } 
    // If we've scrolled into the end clones buffer
    else if (scrollLeft > track.scrollWidth - track.offsetWidth - (totalOriginalWidth * 0.5)) {
      track.scrollTo({ left: scrollLeft - totalOriginalWidth, behavior: 'instant' });
    }
  }

  function updateActiveState() {
    const trackRect = track.getBoundingClientRect();
    const centerX = trackRect.left + trackRect.width / 2;
    let closestCard = null;
    let minDistance = Infinity;
    let virtualIndex = 0;
    
    allCards.forEach((card, i) => {
      const cardRect = card.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const distance = Math.abs(centerX - cardCenter);
      
      if (distance < minDistance) {
        minDistance = distance;
        closestCard = card;
        virtualIndex = (i - clonesCount + originalCards.length) % originalCards.length;
      }
    });

    allCards.forEach(card => {
      const video = card.querySelector('video');
      const animImg = card.querySelector('.way-anim-img'); // Animated WebP image
      const isActive = card === closestCard;
      card.classList.toggle('active', isActive);
      
      // Handle videos (existing logic)
      if (video && video.src && video.src !== window.location.href) {
        if (isActive && !card.classList.contains('paused')) {
          video.play().catch(() => {});
          card.classList.add('playing');
        } else {
          video.pause();
          card.classList.remove('playing');
        }
      }
      
      // Handle animated WebP images (swap src based on active state)
      if (animImg && animImg.dataset.animated && animImg.dataset.static) {
        if (isActive) {
          // Swap to animated version
          if (animImg.src !== animImg.dataset.animated) {
            animImg.src = animImg.dataset.animated;
          }
        } else {
          // Swap to static version
          if (animImg.src !== animImg.dataset.static) {
            animImg.src = animImg.dataset.static;
          }
        }
      }
    });

    if (dots.length > 0) {
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === virtualIndex);
      });
    }
  }

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    handleInfiniteScroll();
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveState, 50);
  }, { passive: true });

  // Initial setup: start at the "real" first card, centered
  setTimeout(() => {
    scrollToCardIndex(clonesCount);
    updateActiveState();
  }, 200);

  // Click handler (for video toggle and side-card snapping)
  track.addEventListener('click', (e) => {
    const card = e.target.closest('.way-card');
    if (!card) return;
    
    if (card.classList.contains('active')) {
      const video = card.querySelector('video');
      if (!video) return;
      if (card.classList.contains('paused')) {
        card.classList.remove('paused');
        video.play().catch(() => {});
      } else {
        card.classList.add('paused');
        video.pause();
      }
    } else {
      const index = allCards.indexOf(card);
      scrollToCardIndex(index);
    }
  });
})();
// 1. UPDATE QTY LOCAL UI
function updatePdpQty(change) {
    const input = document.getElementById('PdpQty');
    if (!input) return; // qty input not present on this page
    let newVal = parseInt(input.value, 10) + change;
    if (newVal < 1) newVal = 1;
    input.value = newVal;
}

// MOBILE CAROUSEL: True infinite loop (scroll forward from last to first)
(function() {
    const slider = document.getElementById('mobileSlider');
    const dots = document.querySelectorAll('.slide-indicators .dot');
    
    if (!slider || dots.length < 2) return;
    
    const slides = slider.querySelectorAll('.slide-item');
    const totalSlides = slides.length;
    const slideWidth = () => slider.offsetWidth;
    
    // Clone first and last slides for infinite effect
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[totalSlides - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    
    slider.appendChild(firstClone);
    slider.insertBefore(lastClone, slides[0]);
    
    // Start at first real slide (after the prepended clone)
    const initScroll = () => {
        slider.scrollLeft = slideWidth();
    };
    
    // Defer initial scroll to ensure layout is ready
    requestAnimationFrame(() => {
        initScroll();
        setTimeout(initScroll, 50); 
    });
    
    let isJumping = false;
    
    // Handle Resize (Keep current slide centered)
    window.addEventListener('resize', () => {
        const width = slideWidth();
        const currentRealIndex = parseInt(slider.dataset.currentIndex || 0, 10);
        slider.scrollLeft = (currentRealIndex + 1) * width;
    });
    
    function updateDots(realIndex) {
        slider.dataset.currentIndex = realIndex;
        dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === realIndex);
        });
    }
    
    slider.addEventListener('scroll', function() {
        if (isJumping) return;
        
        const scrollPos = slider.scrollLeft;
        const width = slideWidth();
        // Use Math.round for closer snap
        const currentIndex = Math.round(scrollPos / width);
        
        // Map to real index (accounting for clones)
        let realIndex = currentIndex - 1; // -1 because of prepended clone
        if (realIndex < 0) realIndex = totalSlides - 1;
        if (realIndex >= totalSlides) realIndex = 0;
        
        updateDots(realIndex);
    });
    
    slider.addEventListener('scrollend', function() {
        if (isJumping) return;
        
        const scrollPos = slider.scrollLeft;
        const width = slideWidth();
        const currentIndex = Math.round(scrollPos / width);
        
        // If at first clone (before real slides), jump to last real slide
        if (currentIndex === 0) {
            isJumping = true;
            slider.style.scrollBehavior = 'auto';
            slider.scrollLeft = totalSlides * width;
            slider.style.scrollBehavior = '';
            isJumping = false;
        }
        
        // If at last clone (after real slides), jump to first real slide
        if (currentIndex === totalSlides + 1) {
            isJumping = true;
            slider.style.scrollBehavior = 'auto';
            slider.scrollLeft = width;
            slider.style.scrollBehavior = '';
            isJumping = false;
        }
    });
    
    // Fallback for browsers without scrollend
    if (!('onscrollend' in window)) {
        let scrollTimeout;
        slider.addEventListener('scroll', function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                slider.dispatchEvent(new Event('scrollend'));
            }, 100);
        });
    }
    
    // Click on dot to scroll
    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            slider.scrollTo({ left: (i + 1) * slideWidth(), behavior: 'smooth' });
        });
    });

    // Auto-Scroll Slider
    let autoSlideInterval;
    function startAutoSlide() {
        stopAutoSlide();
        autoSlideInterval = setInterval(() => {
            const scrollPos = slider.scrollLeft;
            const width = slideWidth();
            const currentIndex = Math.round(scrollPos / width);
            
            // Advance by one
            slider.scrollTo({
                left: (currentIndex + 1) * width,
                behavior: 'smooth'
            });
        }, 3000); // 3 seconds
    }
    
    function stopAutoSlide() {
        if (autoSlideInterval) clearInterval(autoSlideInterval);
    }
    
    // Interactions stop auto-scroll
    slider.addEventListener('touchstart', stopAutoSlide, {passive: true});
    slider.addEventListener('mousedown', stopAutoSlide);
    
    // Start on load
    startAutoSlide();
})();

// WISHLIST - Handled by global WishlistManager (snippets/global-utilities.liquid)
// Uses data-wishlist-btn attribute on buttons

// 2. CHANGE HERO IMAGE with Slide Effect
function changeHeroImage(src, el, direction = 0) {
    const mainImg = document.getElementById('MainImage');
    if(mainImg) {
        if (direction !== 0) {
            // Pure slide: slide out
            mainImg.style.transition = 'transform 0.25s ease-out';
            mainImg.style.transform = `translateX(${direction * -100}%)`;
            
            setTimeout(() => {
                mainImg.style.transition = 'none';
                mainImg.src = src;
                mainImg.style.transform = `translateX(${direction * 100}%)`;
                // Force reflow
                mainImg.offsetHeight;
                // Slide in
                mainImg.style.transition = 'transform 0.25s ease-out';
                mainImg.style.transform = 'translateX(0)';
            }, 250);
        } else {
            // Thumbnail click - instant swap
            mainImg.src = src;
        }
    }
    
    document.querySelectorAll('.thumb-item').forEach(t => t.classList.remove('active'));
    if(el) el.classList.add('active');
}

// SWIPE SUPPORT + AUTO-SCROLL FOR PRODUCT IMAGES
(function() {
    let touchStartX = 0;
    let touchEndX = 0;
    let currentImageIndex = 0;
    let autoScrollTimer = null;
    const AUTO_SCROLL_DELAY = 6000; // 6 seconds - human-friendly pacing
    
    const mediaCanvas = document.querySelector('.media-canvas');
    const thumbs = document.querySelectorAll('.thumb-item');
    
    if (!mediaCanvas || thumbs.length < 2) return;
    
    // Get image source from thumb element
    function getThumbSrc(thumb) {
        // Guard: a thumb with neither data-image-src nor an onclick attribute
        // must not crash (getAttribute('onclick') would be null → .match throws).
        return thumb.dataset.imageSrc || thumb.getAttribute('onclick')?.match(/'([^']+)'/)?.[1];
    }
    
    // Navigate to specific image index
    function goToImage(index, direction) {
        currentImageIndex = index;
        const thumb = thumbs[currentImageIndex];
        const imgSrc = getThumbSrc(thumb);
        if (imgSrc) {
            changeHeroImage(imgSrc, thumb, direction);
        }
    }
    
    // Auto-scroll to next image
    function autoScrollNext() {
        const nextIndex = (currentImageIndex + 1) % thumbs.length;
        goToImage(nextIndex, 1); // direction 1 = slide left (next)
    }
    
    // Reset auto-scroll timer - ALWAYS resets to full duration
    function resetAutoScroll() {
        if (autoScrollTimer) {
            clearTimeout(autoScrollTimer);
        }
        autoScrollTimer = setTimeout(() => {
            autoScrollNext();
            resetAutoScroll(); // Continue the cycle
        }, AUTO_SCROLL_DELAY);
    }
    
    // Stop auto-scroll (e.g., when page is not visible)
    function stopAutoScroll() {
        if (autoScrollTimer) {
            clearTimeout(autoScrollTimer);
            autoScrollTimer = null;
        }
    }
    
    function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > swipeThreshold) {
            let direction;
            if (diff > 0) {
                // Swipe left - next image
                direction = 1;
                currentImageIndex = (currentImageIndex + 1) % thumbs.length;
            } else {
                // Swipe right - previous image
                direction = -1;
                currentImageIndex = (currentImageIndex - 1 + thumbs.length) % thumbs.length;
            }
            const thumb = thumbs[currentImageIndex];
            const imgSrc = getThumbSrc(thumb);
            if (imgSrc) {
                changeHeroImage(imgSrc, thumb, direction);
            }
            
            // Reset timer on manual interaction - starts fresh from full duration
            resetAutoScroll();
        }
    }
    
    mediaCanvas.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    mediaCanvas.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    }, { passive: true });
    
    // Track current index when thumb is clicked + reset timer
    thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
            currentImageIndex = index;
            // Reset timer on manual interaction
            resetAutoScroll();
        });
    });
    
    // Pause auto-scroll when page is hidden (battery saver)
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            stopAutoScroll();
        } else {
            resetAutoScroll();
        }
    });
    
    // Start auto-scroll on page load
    resetAutoScroll();
})();



// Mobile Main Button Logic
window.mobileCartQty = 0;
window._pdpOptimisticQty = window._pdpOptimisticQty || {};
window._pdpAddInFlight = window._pdpAddInFlight || {};

window.getSelectedPdpVariantId = function() {
  const selector = document.getElementById('VariantSelector')
    || document.getElementById('VariantSelectorDesktop')
    || document.querySelector('[data-action="select-variant"]');
  return selector?.value || window.__pdpDefaultVariantId;
};

window.getSelectedPurchaseType = function() {
  return document.querySelector('input[name="purchase_type"]:checked')?.value || 'one_time';
};

window.getSelectedPurchaseProperties = function() {
  return {
    'Purchase Type': window.getSelectedPurchaseType() === 'subscribe'
      ? 'Subscribe and Save'
      : 'One Time Purchase'
  };
};

window.getSelectedPurchaseCartOptions = function() {
  return {
    properties: window.getSelectedPurchaseProperties()
  };
};

window.getPdpVariantData = function(variantId) {
  if (!variantId || !window.nuclear_variants) return null;
  return window.nuclear_variants[String(variantId)] || null;
};

window.getPdpVariantQty = function(variantId) {
  if (!variantId) return 0;
  const cacheKey = `${String(variantId)}::${window.getSelectedPurchaseType()}`;
  if (window._pdpOptimisticQty && Object.prototype.hasOwnProperty.call(window._pdpOptimisticQty, cacheKey)) {
    return window._pdpOptimisticQty[cacheKey];
  }
  if (window.CartManager && typeof CartManager.getItemQty === 'function') {
    return CartManager.getItemQty(String(variantId), window.getSelectedPurchaseCartOptions());
  }
  return 0;
};

window.setPdpVariantQty = function(variantId, qty) {
  if (!variantId) return;
  const cacheKey = `${String(variantId)}::${window.getSelectedPurchaseType()}`;
  window._pdpOptimisticQty[cacheKey] = Math.max(0, parseInt(qty, 10) || 0);
};

window.isPdpAddPending = function(variantId) {
  if (!variantId) return false;
  return !!window._pdpAddInFlight[String(variantId)];
};

window.setPdpAddPending = function(variantId, pending) {
  if (!variantId) return;
  window._pdpAddInFlight[String(variantId)] = !!pending;
};

window.isPdpVariantSoldOut = function(variantId) {
  const variantData = window.getPdpVariantData(variantId);
  if (!variantData) return true;
  if (!variantData.available) return true;
  if (variantData.policy === 'deny' && variantData.quantity <= 0) return true;
  return false;
};

function updateStockStatus(variantId) {
  const variantData = window.getPdpVariantData(variantId);
  const badge = document.getElementById('mobileStockBadge');
  const dot = document.getElementById('mobileStockDot');
  const separator = document.getElementById('mobileStockSeparator');
  const shipTime = document.getElementById('mobileShipTime');

  if (!variantData || !badge) return;

  badge.classList.remove('sold-out', 'low-stock', 'in-stock');

  if (window.isPdpVariantSoldOut(variantId)) {
    badge.classList.add('sold-out');
    badge.textContent = 'Sold Out';
    if (dot) dot.style.display = 'none';
    if (separator) separator.style.display = 'none';
    if (shipTime) shipTime.style.display = 'none';
    return;
  }

  const isLowStock = variantData.inventoryManagement === 'shopify' && variantData.policy === 'deny' && variantData.quantity > 0 && variantData.quantity <= 5;
  if (isLowStock) {
    badge.classList.add('low-stock');
    badge.textContent = `Only ${variantData.quantity} left!`;
    if (dot) dot.style.display = 'none';
    if (separator) separator.style.display = 'none';
    if (shipTime) shipTime.style.display = 'none';
    return;
  }

  badge.classList.add('in-stock');
  badge.textContent = 'In Stock';
  if (dot) dot.style.display = '';
  if (separator) separator.style.display = '';
  if (shipTime) shipTime.style.display = '';
}

function updateStickyPrice(variantId) {
  const variantData = window.getPdpVariantData(variantId);
  if (!variantData) return;

  const stickyPrice = document.getElementById('stickyPrice');
  const stickyMrp = document.getElementById('stickyMrp');
  const stickyComparePrice = document.getElementById('stickyComparePrice');
  const stickyDiscount = document.getElementById('stickyDiscount');
  const stickyVariantImage = document.getElementById('stickyVariantImage');

  if (stickyPrice) stickyPrice.textContent = variantData.priceMoney;
  if (stickyVariantImage && variantData.image) {
    stickyVariantImage.src = variantData.image;
  }

  const hasCompare = variantData.compareAtPrice > variantData.price;
  if (stickyMrp) stickyMrp.style.display = hasCompare ? '' : 'none';
  if (stickyDiscount) stickyDiscount.style.display = hasCompare ? '' : 'none';
  if (stickyComparePrice) stickyComparePrice.textContent = variantData.compareAtMoney;
  if (stickyDiscount) {
    if (hasCompare) {
      const discount = Math.round(((variantData.compareAtPrice - variantData.price) * 100) / variantData.compareAtPrice);
      stickyDiscount.textContent = `(${discount}% off)`;
    } else {
      stickyDiscount.textContent = '';
    }
  }
}

function updatePurchaseCopy(variantId) {
  const variantData = window.getPdpVariantData(variantId);
  if (!variantData) return;

  document.querySelectorAll('.pdp-price').forEach((priceEl) => {
    priceEl.textContent = variantData.priceMoney;
  });

  const mobileAddPriceText = document.getElementById('mobileAddPriceText');
  if (mobileAddPriceText) mobileAddPriceText.textContent = variantData.priceMoney;

  const subscribeSavingsText = document.getElementById('subscribeSavingsText');
  if (subscribeSavingsText) {
    const savingsAmount = Math.round(variantData.price * 0.1 / 100);
      subscribeSavingsText.textContent = `Save up to \u20B9${savingsAmount}, skip or cancel anytime.`;
  }

  updateStickyPrice(variantId);
}

function syncPurchaseAvailability(variantId) {
  const isSoldOut = window.isPdpVariantSoldOut(variantId);
  const splitContainer = document.getElementById('splitBtnContainer');
  const mobileNotifyBtn = document.getElementById('mobileNotifyBtn');
  const stickyNotifyBtn = document.getElementById('stickyNotifyBtn');
  const stickyAddBtn = document.getElementById('stickyAddBtn');
  const stickyShip = document.getElementById('shippingUrgency');
  const stickyAddAction = document.getElementById('stickyAddAction');

  if (splitContainer) splitContainer.style.display = isSoldOut ? 'none' : '';
  if (mobileNotifyBtn) mobileNotifyBtn.style.display = isSoldOut ? '' : 'none';
  if (stickyNotifyBtn) stickyNotifyBtn.style.display = isSoldOut ? '' : 'none';
  if (stickyAddBtn) stickyAddBtn.style.display = isSoldOut ? 'none' : '';
  if (stickyShip) stickyShip.style.display = isSoldOut ? 'none' : '';
  if (stickyAddAction) stickyAddAction.dataset.defaultVariantId = variantId;
}

function updateDesktopAddState(variantId) {
  const variantData = window.getPdpVariantData(variantId);
  if (!variantData) return;

  document.querySelectorAll('[data-action="add-to-cart"]').forEach((btn) => {
    btn.dataset.variantId = variantId;
    btn.dataset.maxInventory = variantData.maxInventory;
    btn.disabled = window.isPdpVariantSoldOut(variantId);
  });

  document.querySelectorAll('.pdp-qty-input').forEach((input) => {
    if (variantData.policy === 'deny' && variantData.maxInventory >= 0) {
      input.max = variantData.maxInventory;
      if (variantData.maxInventory > 0 && parseInt(input.value, 10) > variantData.maxInventory) {
        input.value = variantData.maxInventory;
      }
    } else {
      input.removeAttribute('max');
    }
  });
}

function syncButtons(qty, variantId) {
  const selectedVariantId = String(variantId || window.getSelectedPdpVariantId());
  const nextQty = Math.max(0, parseInt(qty, 10) || 0);

  window.setPdpVariantQty(selectedVariantId, nextQty);
  window.mobileCartQty = nextQty;
  window.stickyCartQty = nextQty;

  const mobileBtn = document.getElementById('mobileAddBtn');
  const container = document.getElementById('splitBtnContainer');

  if (mobileBtn) {
    const addState = mobileBtn.querySelector('.mobile-btn-state-add');
    const addedState = mobileBtn.querySelector('.mobile-btn-state-added');

    if (nextQty > 0) {
      if (container) {
        container.classList.add('is-split');
        mobileBtn.classList.add('split-active');
      }
      if (addState) addState.style.display = 'none';
      if (addedState) addedState.style.display = 'flex';
      const qtyVal = document.getElementById('mobileQtyValue');
      if (qtyVal) qtyVal.textContent = nextQty;
    } else {
      if (addState) addState.style.display = 'block';
      if (addedState) addedState.style.display = 'none';
      if (container) {
        container.classList.remove('is-split');
        mobileBtn.classList.remove('split-active');
      }
    }
  }

  const stickyBtn = document.getElementById('stickyAddBtn');
  if (stickyBtn) {
    const stickyAddState = stickyBtn.querySelector('.sticky-btn-state-add');
    const stickyAddedState = stickyBtn.querySelector('.sticky-btn-state-added');

    if (nextQty > 0) {
      if (stickyAddState) stickyAddState.style.display = 'none';
      if (stickyAddedState) stickyAddedState.style.display = 'flex';
      const stickyQtyVal = document.getElementById('stickyQtyValue');
      if (stickyQtyVal) stickyQtyVal.textContent = nextQty;
    } else {
      if (stickyAddState) stickyAddState.style.display = 'flex';
      if (stickyAddedState) stickyAddedState.style.display = 'none';
    }
  }
}

window.syncButtons = syncButtons;

window.syncPdpPurchaseState = function(variantId) {
  const selectedVariantId = String(variantId || window.getSelectedPdpVariantId());
  const selector = document.getElementById('VariantSelector');
  if (selector && selector.value !== selectedVariantId) {
    selector.value = selectedVariantId;
  }

  if (typeof window.syncStackVariantState === 'function') {
    window.syncStackVariantState(selectedVariantId);
  }

  updatePurchaseCopy(selectedVariantId);
  updateStockStatus(selectedVariantId);
  syncPurchaseAvailability(selectedVariantId);
  updateDesktopAddState(selectedVariantId);

  if (window.isPdpVariantSoldOut(selectedVariantId)) {
    syncButtons(0, selectedVariantId);
    return;
  }

  const selectedQty = window.getPdpVariantQty(selectedVariantId);
  syncButtons(selectedQty, selectedVariantId);
};

/* ============================================================
   STICKY CART ADD / QTY UPDATE — robust flow
   ============================================================
   Rules followed here (these are what was wrong before):

   1. Optimistic cache (_pdpOptimisticQty) is updated *synchronously*
      on click. The UI reads from this cache, so a click feels instant.
   2. The cart:updated listener (below) is the SINGLE place that
      reconciles optimistic state with server truth. We don't call
      syncPdpPurchaseState in onSuccess — that would race with
      cart:updated and cause the "Added → reverts to Add → flickers
      back to Added" bug.
   3. While a request is in flight for a given variant, the +/-/ADD
      buttons are visually disabled. No spam-click duplicates.
   4. On error, we revert the optimistic cache to the pre-click value.
      We do NOT call CartManager.scheduleSync() ourselves — addItem
      already does that, and we'd double-sync.
   5. Exactly one toast per user action. CartManager no longer toasts
      internally, so the toast here is the only one users see.
   ============================================================ */

// Lock visuals on the sticky cart buttons while a request is in flight.
// We can't just .disabled the <button> because the qty controls are <span>;
// we toggle a class and the click handlers honor it.
function setStickyCartBusy(busy) {
  const cart = document.getElementById('mobileCartBar');
  if (cart) cart.classList.toggle('is-busy', !!busy);
  const addBtn = document.getElementById('stickyAddAction');
  if (addBtn) addBtn.disabled = !!busy;
}

function isStickyCartBusy() {
  const cart = document.getElementById('mobileCartBar');
  return !!(cart && cart.classList.contains('is-busy'));
}

// Mobile Add to Cart - Uses CartManager
function addToCartFromMobile(options = {}) {
  const openDrawerOnAdd = options === true || options.openDrawer === true;
  const variantId = window.getSelectedPdpVariantId();
  const currentQty = window.getPdpVariantQty(variantId);
  const variantData = window.getPdpVariantData(variantId);
  const totalVariantQty = window.CartManager && typeof CartManager.getVariantQty === 'function'
    ? CartManager.getVariantQty(variantId)
    : currentQty;
  const cartOptions = window.getSelectedPurchaseCartOptions();

  if (window.isPdpVariantSoldOut(variantId)) return;
  if (variantData && variantData.policy === 'deny' && totalVariantQty >= variantData.maxInventory) {
    Toast.error(`Only ${variantData.maxInventory} available!`);
    return;
  }
  // Hard guard: refuse to start a new request while one is already running
  // for this variant. Without this, fast double-taps caused duplicate adds.
  if (window.isPdpAddPending(variantId) || isStickyCartBusy()) {
    if (openDrawerOnAdd && currentQty > 0) {
      requestAnimationFrame(() => expandDrawer());
    }
    return;
  }
  if (currentQty > 0) {
    syncButtons(currentQty, variantId);
    if (openDrawerOnAdd) {
      requestAnimationFrame(() => expandDrawer());
    }
    return;
  }

  // Optimistic state — update cache + UI BEFORE the API call so the
  // user sees the button transition to ADDED immediately.
  window.setPdpAddPending(variantId, true);
  window.setPdpVariantQty(variantId, currentQty + 1);
  setStickyCartBusy(true);
  syncButtons(currentQty + 1, variantId);
  if (openDrawerOnAdd) {
    requestAnimationFrame(() => expandDrawer());
  }

  CartManager.addItem(variantId, 1, {
    ...cartOptions,
    onSuccess: function() {
      window.setPdpAddPending(variantId, false);
      setStickyCartBusy(false);
      Toast.success(window.nuclear.strings?.added || 'Added to cart!');
      // Don't call syncPdpPurchaseState here. cart:updated will fire
      // right after this with the authoritative server cart and
      // sync the UI then. Calling it here races and causes flicker.
    },
    onError: function() {
      window.setPdpAddPending(variantId, false);
      setStickyCartBusy(false);
      // Roll back the optimistic cache to the pre-click value.
      window.setPdpVariantQty(variantId, currentQty);
      syncButtons(currentQty, variantId);
      if (openDrawerOnAdd) collapseDrawer();
      Toast.error('Could not add to cart');
    }
  });
}

// Mobile Qty Update - Uses CartManager
function updateMobileQty(change) {
  // Same lock — prevents the "+ + + + - + +" spam-click from queueing
  // a flurry of conflicting cart updates.
  if (isStickyCartBusy()) return;

  const variantId = window.getSelectedPdpVariantId();
  const currentQty = window.getPdpVariantQty(variantId);
  const variantData = window.getPdpVariantData(variantId);
  const totalVariantQty = window.CartManager && typeof CartManager.getVariantQty === 'function'
    ? CartManager.getVariantQty(variantId)
    : currentQty;
  const cartOptions = window.getSelectedPurchaseCartOptions();
  let newQty = currentQty + change;
  if (newQty < 1) newQty = 0;

  if (newQty === currentQty) return;

  if (change > 0 && variantData && variantData.policy === 'deny' && totalVariantQty + change > variantData.maxInventory) {
    Toast.error(`Only ${variantData.maxInventory} available!`);
    return;
  }

  // Optimistic cache + UI update so the qty pill responds instantly.
  window.setPdpVariantQty(variantId, newQty);
  setStickyCartBusy(true);
  syncButtons(newQty, variantId);

  CartManager.changeItem(variantId, newQty, {
    ...cartOptions,
    onSuccess: function() {
      setStickyCartBusy(false);
      // cart:updated fires next and reconciles to server truth.
    },
    onError: function() {
      setStickyCartBusy(false);
      window.setPdpVariantQty(variantId, currentQty);
      syncButtons(currentQty, variantId);
      Toast.error('Could not update cart');
    }
  });
}

// Idempotent listener registration. Without this guard, SPA navigation
// re-executes this script (page-transitions.js revives inline script
// elements inside the main content area) and accumulates one extra
// `cart:updated` listener per nav, all dispatching to old DOM nodes.
if (!window._pdpCartUpdatedListenerBound) {
  window.addEventListener('cart:updated', function(event) {
    const cart = event.detail || {};
    const selectedVariantId = window.getSelectedPdpVariantId();
    if (!selectedVariantId) return;

    const matchingItem = window.CartManager && typeof CartManager.getItem === 'function'
      ? CartManager.getItem(selectedVariantId, {
          cart: cart,
          properties: window.getSelectedPurchaseProperties()
        })
      : null;
    window.setPdpVariantQty(selectedVariantId, matchingItem ? matchingItem.quantity : 0);
    window.syncPdpPurchaseState(selectedVariantId);
  });
  window._pdpCartUpdatedListenerBound = true;
}

function initPdpPurchaseState() {
  window.syncPdpPurchaseState(window.getSelectedPdpVariantId());
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdpPurchaseState);
} else {
  initPdpPurchaseState();
}

if (!window._pdpPurchaseStateListenerBound) {
  window.addEventListener('pageTransitionComplete', initPdpPurchaseState);
  window._pdpPurchaseStateListenerBound = true;
}

// Legacy Alias - points to CartManager for backwards compatibility
window.fetchCartCount = function() {
  return CartManager.sync();
};

// Insert Animation CSS if not present
const styleCheck = document.getElementById('cart-anim-style');
if (!styleCheck) {
  const style = document.createElement('style');
  style.id = 'cart-anim-style';
  style.innerHTML = `
    @keyframes cartBump {
      0% { transform: scale(1); }
      40% { transform: scale(1.2); }
      100% { transform: scale(1); }
    }
    .cart-bump {
      animation: cartBump 0.3s ease-out forwards;
    }
    .cart-count-bubble.hidden { display: none; }
  `;
  document.head.appendChild(style);
}
